module.exports = {
  NOT_STARTED: 'notStarted',
  IN_PROGRESS: 'inProgress',
  COMPLETE: 'complete',
  OFFLINE: 'offline',
  SAVED: 'saved',
  SUBMITTED: 'submitted'
}
